import { Link } from 'react-router-dom';
import styles from './InjuredAthletesSection.module.scss';
import { InjuredAthleteSummary } from '../types';
import { formatFullName } from '../../utils/functions';
import { InjuryBadge } from '../../shared/InjuryBadge/InjuryBadge';
import { INJURY_BODY_ZONE, INJURY_SEVERITY } from '../../enums/injuries';

interface InjuredAthletesSectionProps {
  injured: InjuredAthleteSummary[];
}

/**
 * Sezione "Infortunati" sotto la matrice/card-grid Readiness: dedup del
 * blocco un tempo duplicato identico in entrambe le viste di
 * `TeamReadinessTab` (matrix + card), spostato da inline-style a SCSS module.
 * Nessun cambio visivo: stessi valori, stesso layout.
 */
export default function InjuredAthletesSection({ injured }: InjuredAthletesSectionProps) {
  if (injured.length === 0) return null;

  return (
    <div className={styles.section}>
      <p className={styles.title}>Infortunati ({injured.length})</p>
      <div className={styles.list}>
        {injured.map((inj) => (
          <Link key={inj.injuryId} to={`/dashboard/users/${inj.athleteId}`} className={styles.item}>
            <span className={styles.itemName}>{formatFullName(inj.firstName, inj.lastName)}</span>
            <InjuryBadge
              size="sm"
              injury={{
                injuryId: inj.injuryId,
                athleteId: inj.athleteId,
                bodyZone: inj.bodyZone as INJURY_BODY_ZONE,
                daysOut: inj.daysOut,
                severity: inj.severity as INJURY_SEVERITY,
                rtpPhase: inj.rtpPhase,
                expectedReturnDate: inj.expectedReturnDate,
              }}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}
